import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { selectSelectedCompany } from "store/companySlice";

import Loader from "layout/atoms/Loader";
import { Tab, TabsList } from "layout/atoms/Tabs/styles";

import { COMPANY_SETTINGS_PATH } from "./SettingsLayout";

const subTabs = [{ name: "members", to: `${COMPANY_SETTINGS_PATH}/members` }];

function CompanySettings() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCompany = useSelector(selectSelectedCompany);

  if (!selectedCompany) {
    return <Loader />;
  }

  if (selectedCompany.role !== "PRIMARY_OWNER") {
    return <Navigate to="/admin/settings" replace />;
  }

  return (
    <>
      <TabsList>
        {subTabs.map((tab) => (
          <Tab
            key={tab.name}
            isActive={location.pathname.startsWith(tab.to)}
            onClick={() => navigate(tab.to)}
          >
            {t(`settings.company.tabs.${tab.name}`)}
          </Tab>
        ))}
      </TabsList>
      <Outlet />
    </>
  );
}

export default CompanySettings;
